import React from "react";
import { Divider as PDivider } from 'primereact/divider';
import {extract, renderValue} from "../../utils";
import {withFormikFormControl} from "../../FormikFormControl";

const GPT = (props) => {

    return <div />
};
export default withFormikFormControl({  })(GPT);
